export default "__VITE_ASSET__01457315__"